// Skinline: "Show more reviews".
// La página trae hasta 250 reseñas; el botón va mostrando las ocultas de [per_page] en [per_page].
// Si se acaban y hay otra página (más de 250), la carga con la Section Rendering API y sigue.
(function () {
  function formatNumber(n, sep) {
    return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, sep);
  }

  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';

    const list = root.querySelector('[data-skrv-list]');
    const showing = root.querySelector('[data-skrv-showing]');
    if (!list) return;
    const perPage = parseInt(list.dataset.perPage, 10) || 20;

    const updateShowing = () => {
      if (!showing) return;
      const shown = list.querySelectorAll('.skrv-lcard:not(.is-hidden)').length;
      showing.textContent = showing.dataset.template
        .replace('[shown]', formatNumber(shown, showing.dataset.sep || ''))
        .replace('[total]', showing.dataset.total);
    };

    const revealNext = () => {
      list
        .querySelectorAll('.skrv-lcard.is-hidden')
        .forEach((card, i) => i < perPage && card.classList.remove('is-hidden'));
      return list.querySelector('.skrv-lcard.is-hidden') !== null;
    };

    root.addEventListener('click', async (event) => {
      const button = event.target.closest('[data-skrv-more]');
      if (!button) return;
      event.preventDefault();

      if (list.querySelector('.skrv-lcard.is-hidden')) {
        const more = revealNext();
        updateShowing();
        if (!more && !button.dataset.next) button.remove();
        return;
      }

      if (!button.dataset.next) {
        button.remove();
        return;
      }

      button.setAttribute('aria-busy', 'true');
      try {
        const url = new URL(button.dataset.next, window.location.origin);
        url.searchParams.set('section_id', root.dataset.sectionId);
        const html = await (await fetch(url)).text();
        const doc = new DOMParser().parseFromString(html, 'text/html');

        doc.querySelectorAll('[data-skrv-list] .skrv-lcard').forEach((card) => list.appendChild(card));

        const next = doc.querySelector('[data-skrv-more][data-next]');
        if (next) button.dataset.next = next.dataset.next;
        else delete button.dataset.next;
        button.removeAttribute('aria-busy');
        updateShowing();
        if (!list.querySelector('.skrv-lcard.is-hidden') && !button.dataset.next) button.remove();
      } catch (e) {
        // Si falla, navegar a la página siguiente de forma normal
        window.location.href = button.dataset.next;
      }
    });
  }

  const initAll = () => document.querySelectorAll('[data-skrv]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
